import { ManageUser, StoragePlan } from "@induz/sdk";

/**
 * Normalizes protobuf numeric fields (number | Long) to a finite number or null.
 * @param {*} value - Raw proto field (number, Long-like object, or other).
 * @return {?number} Finite number, or null if missing or not finite.
 */
export function planFieldToNumber(value) {
  if (value === null || value === undefined) return null;
  if (typeof value === "number") return Number.isFinite(value) ? value : null;
  if (typeof value === "object" && typeof value.toNumber === "function") {
    try {
      const n = value.toNumber();
      return Number.isFinite(n) ? n : null;
    } catch {
      return null;
    }
  }
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

/**
 * `StoragePlan.trash` for the signed-in user's current plan (same API shape as maxSpaces, maxVersions, etc.).
 * @return {Promise<number|null>} Numeric value from the backend, or null if unavailable.
 */
export async function fetchUserPlanTrashRetentionDays() {
  const mail =
    typeof sessionStorage !== "undefined" ? sessionStorage.getItem("mail") : null;
  const userInfo = await ManageUser.getUserDetails(mail || undefined, false);
  const planId = userInfo?.getPlan?.();
  if (planId === undefined || planId === null) return null;
  const id = typeof planId === "number" ? planId : parseInt(String(planId), 10);
  if (!Number.isFinite(id)) return null;
  const sp = new StoragePlan();
  sp.setPlanId(id);
  const plan = await sp.getPlan();
  return planFieldToNumber(plan.getTrash?.());
}

/**
 * User-facing trash banner: uses plan `trash` when it is a positive number; otherwise a generic line (no hardcoded day count).
 * @param {number|null|undefined} days - Trash retention from `getTrash()`, if known.
 * @return {string} Banner sentence for the trash tab.
 */
export function formatTrashRetentionBanner(days) {
  if (typeof days === "number" && days > 0) {
    return `Items in trash will be deleted forever after ${days} days`;
  }
  return "Items in trash will be deleted according to your plan.";
}

